module.exports = __webpack_public_path__ + "static/img/fr-18.f7ce13c6.png";